import { Lightbulb } from "lucide-react";
import { useTranslation } from "react-i18next";

export function SuggestionChip({ text, onAccept }: { text: string; onAccept?: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-wrap items-center gap-2 rounded-md border border-secondary-muted bg-secondary-subtle px-3 py-2">
      <Lightbulb aria-hidden="true" className="h-4 w-4 shrink-0 text-accent" />
      <span className="text-sm text-heading">{t("questionnaire.suggestion", { text })}</span>
      {onAccept ? (
        <button
          type="button"
          onClick={onAccept}
          className="ml-auto min-h-9 rounded-full border border-secondary px-3 text-sm font-semibold text-heading transition-colors hover:bg-surface focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-focus"
        >
          {t("questionnaire.useThis")}
        </button>
      ) : null}
    </div>
  );
}
